import React, { useState, useEffect } from 'react';
import '../../Availability/Availability.css';

import MyCalendar from './toast.ui.js';

import { connect } from 'react-redux';
import CollegePageContainer from '../../Container/CollegePageContainer';
// import axios from "axios"
// import { PORT } from "../../../config"
import { API } from '../../../API';
import { permIndices } from '../../../Permissions';
import Auth from "../../../Auth/Auth";
import moment from 'moment/moment';

// import DatePicker from "../User/DateRange";

const CollegeCalendar = (props) => {
  let newBookingProps = props.location.state || {};
  let [isAbleToEdit,setIsAbleToEdit] = useState(false)
  let [startDate, setStartDate] = useState(moment(new Date()).startOf("month").add(-1, 'days').startOf("month").format("YYYY-MM-DD"))
  let [endDate, setEndDate] = useState(moment(new Date()).endOf("month").add(1, 'days').endOf("month").format("YYYY-MM-DD"))
  const [isLoadCalendar, setIsLoadCalendar] = useState(true)
  const [loadedMonth, setLoadedMonth] = useState([])

  const isMonthLoaded = (year, month) => {
    return loadedMonth.includes(`${year}-${month}`);
  }

  const loadRangeOfMonths = (startDate, endDate) => {
    // Convert the start and end dates to Moment objects
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const loadedMonths = [];
    // Loop through each month in the range and load the data if it hasn't been loaded before
    let currentMoment = startMoment.clone();
    while (currentMoment <= endMoment) {
      const year = currentMoment.year();
      const month = currentMoment.month() + 1; // add 1 to convert from 0-indexed to 1-indexed
      if (!isMonthLoaded(year, month)) {
        loadedMonths.push(`${year}-${month}`);
      }
      currentMoment = currentMoment.add(1, 'months');
    }

    return loadedMonths;
  }

  // temporary - for testing
  // teacher = {
  //   teacher_id: "5e7941e064726604d8a45698",
  //   teacher_name: "Tess"
  // }
  // console.log(teacher)
  const isSelect = (time, date) => {
    let newdate = moment(date).format('MM-DD-YYYY');
    const userData = props.user;
    let flag = false;
    if (userData.rules) {
      if (userData.rules[0][newdate] && userData.rules[0][newdate].time) {
        flag = userData.rules[0][newdate].time.includes(time);
        return flag;
      }
    }
    return flag;
  };

  // Get admin, campus, bookings
  let [allBookings, setAllBookings] = useState([]);
  const [qualifications, setQualifications] = useState([])
  const [simpleQualifications, setSimpleQualifications] = useState([])

  useEffect(() => {
    Auth.authCheck(1 << permIndices.ed_book)
        .then((res) => {
          setIsAbleToEdit( res.authenticated )
        })
    if (isLoadCalendar) {
      //set date when create bookings in calendar
      const calendarDate = window.localStorage.getItem("calendarDate")
      if (moment(calendarDate, "YYYY-MM-DD", true).isValid()) {
        startDate = moment(calendarDate).startOf("month").add(-1, 'days').startOf("month").format("YYYY-MM-DD");
        endDate = moment(calendarDate).endOf("month").add(1, 'days').endOf("month").format("YYYY-MM-DD");
        window.localStorage.setItem("calendarDate", null)
      }
      const listMonth = loadRangeOfMonths(startDate, endDate)
      setLoadedMonth(month => ([...month, ...listMonth]))
      setIsLoadCalendar(false)
      API.getCampusBookingsByInstitutionIDPaginationV2(props.institution._id, startDate, endDate)
        .then((result) => {
          let list = result.data.data
          setAllBookings( preState => ([...preState, ...list]))
        })
        .catch((err) => {
          setIsLoadCalendar(false)
          console.log(err)
        })

      // check simpleQualification list
      if(!props.simpleQualifications?.length) {
        API.getSimpleQualification().then(res => {
          setSimpleQualifications(res?.data?.data)
        })
      }
    }
  }, [isLoadCalendar]);

  useEffect(() => {
    API.getQualificationList().then(result => setQualifications(result?.data?.data))
  }, [])

  const getAllBookings = () => {
    API.getCampusBookingsByInstitutionID(props.institution._id)
      .then((result) => {
        let list = result.data;
        list = list.filter((booking) => {
          return !booking.cancelled_by_inst;
        });
        setAllBookings(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const tabs = [
    {
      text: 'Calendar',
      pathname: '/CollegeCalendar',
      active: true,
    },
    {
      text: 'Job List',
      pathname: '/CollegeJobList',
    },
  ];

  return (
    <CollegePageContainer
      header='Calendar'
      user={props.user}
      tabs={tabs}
      viewbookings={props.viewbookings}
    >
      <MyCalendar
        user={props.user}
        institution={props.institution}
        campuses={props.campuses}
        isSelect={isSelect}
        bookings={allBookings}
        classes={props?.classes?.map(ele => {
          return {
            ...ele,
            expired_time: ele.expired_time || ''
          }
        }).filter(ele => {
          if(ele?.reference_name != 'unnamed') {
            if(props.user.role !== 'customer') {
              return props.user.campuses.includes(ele.campus_id)
            }
            else {
              return true
            }
          }
        })}
        editbookings={isAbleToEdit}
        newBookingProps={newBookingProps}
        setAllBookings={setAllBookings}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        setIsLoadCalendar={setIsLoadCalendar}
        loadedMonth={loadedMonth}
        qualifications={qualifications}
        simpleQualifications={props.simpleQualifications?.length ? props.simpleQualifications : simpleQualifications}
      />
    </CollegePageContainer>
  );
};

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses,
    classes: state.college.classes,
    viewbookings: state.college.user.permissions
      ? state.college.user.permissions & (1 << permIndices.vi_book)
      : 1,
    editbookings: state.college.user.permissions
      ? state.college.user.permissions & (1 << permIndices.ed_book)
      : 1,
    simpleQualifications: state.user?.simpleQualifications || []
  };
}

export default connect(mapStateToProps)(CollegeCalendar);
